import classNames from "classnames";
import React from "react";
import { useAudioRecorder, useVoiceIntensity } from "../../../hooks/useRecorder";

export const MicroPhoneSvg = () => {
  return (
    <svg width="19" height="26" viewBox="0 0 19 26" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M9.50008 16.3333C11.7134 16.3333 13.5001 14.5466 13.5001 12.3333V4.33325C13.5001 2.11992 11.7134 0.333252 9.50008 0.333252C7.28675 0.333252 5.50008 2.11992 5.50008 4.33325V12.3333C5.50008 14.5466 7.28675 16.3333 9.50008 16.3333ZM8.16675 4.33325C8.16675 3.59992 8.76675 2.99992 9.50008 2.99992C10.2334 2.99992 10.8334 3.59992 10.8334 4.33325V12.3333C10.8334 13.0666 10.2334 13.6666 9.50008 13.6666C8.76675 13.6666 8.16675 13.0666 8.16675 12.3333V4.33325ZM16.1667 12.3333C16.1667 16.0133 13.1801 18.9999 9.50008 18.9999C5.82008 18.9999 2.83341 16.0133 2.83341 12.3333H0.166748C0.166748 17.0399 3.64675 20.9066 8.16675 21.5599V25.6666H10.8334V21.5599C15.3534 20.9066 18.8334 17.0399 18.8334 12.3333H16.1667Z" fill="white" />
    </svg>
  );
}

export const MicroPhoneOffSvg = () => {
  return <div>

  </div>
}

export const Radar = ({ children, classNameRadio2, classNameRadio1, allowradar }) => {
  return (
    <div className="relative w-full h-screen bg-[white]/1 flex justify-center items-center">
      <div className={classNames("absolute rounded-full border-2", classNameRadio1, { 'animate-radar': allowradar })}></div>
      <div className={classNames("absolute rounded-full border-2 delay-200", classNameRadio2, { 'animate-radar': allowradar })}></div>
      <div className="absolute w-fit w-fit rounded-full bg-[white]/1 flex items-center justify-center">
        {children}
      </div>
    </div>
  );
};

export const Mic = ({ className }) => {
  return (
    <div className={classNames("w-[48px] h-[48px] bg-LightBlue-500 rounded-full flex justify-center items-center", className)}>
      <MicroPhoneSvg />
    </div>
  );
};

export const RadarMic = ({ isRecording}) => {
  return (
    <div className="w-[70px] h-[70px] flex justify-center items-center overflow-hidden rounded-full">
      <Radar allowradar={isRecording} classNameRadio1={"bg-LightBlue-500/50 border-LightBlue-500/50 h-[55px] w-[55px]"} classNameRadio2={"bg-LightBlue-500/50 border-LightBlue-500/50 h-[60px] w-[60px]"}>
        <Mic />
      </Radar>
    </div>
  );
};


export const VoiceIntensityMeter = ({getColor}) => {
  const intensity = useVoiceIntensity();

  const getBars = () => {
    const totalBars = 10;
    const intensityPerBar = intensity / 255;
    const filledBars = Math.floor(intensityPerBar * totalBars);

    return Array.from({ length: totalBars }, (_, index) => (
      <div
        key={index}
        className={`w-3 h-10 rounded ${getColor(index < filledBars)}`}
      />
    ));
  };

  return <div className="flex gap-4">{getBars()}</div>;
};

export const VoiceRecorder = ({ButtonPlay}) => {
  const {
    isRecording,
    startRecording,
    stopRecording,
    time,
    getAudioFile,
    audioUrl,
    resetRecording
  } = useAudioRecorder();
  return (
    <div className="flex flex-col items-center gap-4">
      <RadarMic isRecording={isRecording}/>
      <VoiceIntensityMeter getColor={(isActive) => isActive ? 'bg-LightBlue-500' : 'bg-[white]'} />
      <div className="text-[white] mb-4">{time}</div>
      <ButtonPlay  {...{
        getAudioFile,
        isRecording,
        startRecording,
        stopRecording,
        resetRecording,
        audioUrl
      }}/>
    </div>
  );
}

